module.exports = {
	createExportMenu: function (chart, chartName, excelUrl, csvUrl) {
		var exportMenuLabel = chart.language.locale.download || 'Export as:';
		chart.exporting.menu = new window.am4core.ExportMenu();
		chart.exporting.useWebFonts = false;
		chart.exporting.menu.items = [{ 'label': ' ', 'menu': [{ 'label': exportMenuLabel }] }];
		chart.exporting.filePrefix = chartName;
		chart.exporting.backgroundColor = window.am4core.color('white');

		if (excelUrl) {
			chart.exporting.menu.items[0].menu.push({
				label: 'Excel',
				type: 'custom',
				options: {
					callback: function() {
						window.location.href = excelUrl;
					}
				}
			});
		}

		if (csvUrl) {
			chart.exporting.menu.items[0].menu.push({
				label: 'CSV',
				type: 'custom',
				options: {
					callback: function() {
						window.location.href = csvUrl;
					}
				}
			});
		}

		chart.exporting.menu.items[0].menu.push({
			label: 'PNG',
			type: 'custom',
			options: {
				callback: function() {
					$.getScript('/Static/js/vendor/canvg.js',
						function() {
							chart.exporting.export('png');
						});
				}
			}
		});
	}
};
